import { describeFields, FieldWidget } from '../common/fields';
import { RoomSchema } from './schemas';

export const ROOM_FIELDS = describeFields(RoomSchema, {
  id: {},
  location: { widget: FieldWidget.Text },
  code: {},
  label: {},
});
